define('LoginRegister.Login.View.Extension', ['LoginRegister.Login.View', 'underscore'], function (
  View,
  _
) {
  'use strict';

  return _.extend(View.prototype, {
    initialize: _.wrap(View.prototype.initialize, function (fn) {
      var result = fn.apply(this, _.toArray(arguments).slice(1));
      this.showAlert = true;

      this.on(
        'afterViewRender',
        function () {
          if (this.showAlert) {
            this.showAlert = false;

            this.showWarningMessage(
              "If this is your first visit to our new site you will need to reset your password. Please click 'Reset password' below."
            );
          } else {
            var warningView = this.$('[data-confirm-message]');

            warningView && warningView.remove();
          }
        },
        this
      );

      return result;
    })
  });
});
